import React from 'react';
import { faLongArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '../FontAwesomeIcon';
import { Button, ButtonProps } from '../Button';

import Style from './BackButton.module.less';
import { classes } from '../../lib';

export const BackButton = ({
    children,
    className,
    ...props
}: ButtonProps): JSX.Element => (
    <Button
        icon={<FontAwesomeIcon icon={faLongArrowLeft} />}
        {...props}
        type="link"
        size="small"
        className={classes(Style.backButton, className)}>
        {children}
    </Button>
);
